function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Button from 'components/Form/Button';
import PencilIcon from 'svg/pencil.svg';
import noteShape from 'shapes/noteShape';
import App from 'modules/App';
import Visit from 'modules/Visit';
import * as selectors from '../../selectors';
import messages from '../../messages';
var _React_PureComponent;
class VisitsNotesBtn extends (_React_PureComponent = React.PureComponent) {
    onClick(evt) {
        evt.stopPropagation();
        if (this.props.floatingModal) {
            this.props.onCloseFloatingModal();
            return;
        }
        this.props.onOpenFloatingModal();
    }
    render() {
        const { activeVisit, notes, phiSet } = this.props;
        const visits = get(phiSet, 'visits', []);
        if (!activeVisit && (!visits.length || !notes.length)) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Button, {
            id: "VisitsNotesBtn",
            styleModifier: "transparent-primary",
            onClick: (evt)=>this.onClick(evt),
            children: [
                /*#__PURE__*/ _jsx(PencilIcon, {
                    className: "btn__icon mr-2"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.visitsNotes))
            ]
        });
    }
}
_define_property(VisitsNotesBtn, "propTypes", {
    // Explicit props
    phiSet: PropTypes.shape({
        visits: PropTypes.arrayOf(Visit.shapes.visit)
    }),
    // Implicit props
    floatingModal: App.shapes.floatingModal,
    notes: PropTypes.arrayOf(noteShape),
    activeVisit: Visit.shapes.visit,
    isInProgress: PropTypes.bool,
    // Implicit actions
    onOpenFloatingModal: PropTypes.func.isRequired,
    onCloseFloatingModal: PropTypes.func.isRequired
});
const mapStateToProps = (state)=>({
        notes: selectors.notes(state),
        activeVisit: Visit.selectors.activeVisit(state),
        floatingModal: App.selectors.floatingModalSelector(Visit.constants.VISIT_NOTES_FM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenFloatingModal: ()=>dispatch(App.actions.openFloatingModal(Visit.constants.VISIT_NOTES_FM, 'notesContainer', 'leftTop')),
        onCloseFloatingModal: ()=>dispatch(App.actions.closeFloatingModal(Visit.constants.VISIT_NOTES_FM))
    });
const ConnectedVisitsNotesBtn = connect(mapStateToProps, mapDispatchToProps)(VisitsNotesBtn);
export default ConnectedVisitsNotesBtn;
